import { heroMeta, heroStats, tickerItems } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full h-[600px] md:h-[760px] lg:h-[820px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20artistic%20background%20with%20warm%20amber%20and%20crimson%20light%20streaks%2C%20soft%20film%20grain%2C%20glowing%20abstract%20shapes%2C%20high%20contrast%20editorial%20magazine%20aesthetic%2C%20no%20text&width=1920&height=1200&seq=kl91-hero-01&orientation=landscape"
          alt="看料91 大主视觉"
          title="看料91热门爆款聚合看板"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent" />

        <div className="relative z-10 w-full h-full flex flex-col justify-end">
          <div className="w-full px-4 md:px-8 pb-14 md:pb-20">
            <div className="max-w-4xl">
              <div className="flex flex-wrap items-center gap-3 md:gap-4 mb-5 md:mb-7 animate-fade-up">
                <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs md:text-sm font-semibold tracking-wide">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-fire-fill" />
                  </span>
                  {heroMeta.titleAccent}
                </span>
                <span className="text-xs md:text-sm text-background-100/90 tracking-[0.2em]">
                  {heroMeta.issue} · {heroMeta.date}
                </span>
              </div>

              <h2
                className="font-heading font-black text-background-50 leading-[1.05] text-4xl md:text-6xl lg:text-7xl animate-fade-up"
                style={{ animationDelay: '0.1s' }}
              >
                看料91
                <span className="block text-accent-400 mt-2 md:mt-3">热门 · 爆款</span>
              </h2>

              <p
                className="mt-6 md:mt-8 text-background-100/85 text-base md:text-lg leading-relaxed max-w-2xl animate-fade-up"
                style={{ animationDelay: '0.2s' }}
              >
                {heroMeta.description}
              </p>

              <div
                className="mt-8 md:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4 animate-fade-up"
                style={{ animationDelay: '0.3s' }}
              >
                <a
                  href="#board"
                  className="inline-flex items-center justify-center gap-2 px-6 md:px-7 py-3 md:py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-bar-chart-2-line" />
                  </span>
                  立即看热度榜单
                </a>
                <a
                  href="#flash"
                  className="inline-flex items-center justify-center gap-2 px-6 md:px-7 py-3 md:py-3.5 rounded-md bg-background-50/10 border border-background-50/35 text-background-50 text-sm md:text-base font-semibold hover:bg-background-50/20 transition-colors whitespace-nowrap"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-flashlight-line" />
                  </span>
                  浏览实时快讯
                </a>
              </div>
            </div>

            <div
              className="mt-12 md:mt-16 grid grid-cols-3 gap-4 md:gap-10 max-w-2xl animate-fade-up"
              style={{ animationDelay: '0.4s' }}
            >
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-t border-background-50/25 pt-4">
                  <div className="flex items-end gap-1">
                    <span className="font-heading font-black text-background-50 text-2xl md:text-4xl">
                      {stat.value}
                    </span>
                    {stat.unit && (
                      <span className="text-background-100/70 text-xs md:text-sm mb-1">{stat.unit}</span>
                    )}
                  </div>
                  <div className="mt-1 text-xs md:text-sm text-background-100/70">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-foreground-950">
        <div className="w-full px-4 md:px-8 py-3 flex items-center gap-4 md:gap-8 overflow-hidden">
          <span className="shrink-0 inline-flex items-center gap-2 text-xs md:text-sm font-semibold text-accent-400">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot" />
            最新动态
          </span>
          <div className="flex items-center gap-6 md:gap-10 overflow-hidden min-w-0 flex-1">
            {tickerItems.map((item, index) => (
              <span
                key={item}
                className={`whitespace-nowrap text-xs md:text-sm text-background-200/80 ${
                  index > 2 ? 'hidden lg:inline' : ''
                }`}
              >
                {item}
              </span>
            ))}
          </div>
          <span className="hidden md:inline shrink-0 ml-auto text-xs text-background-100/60">
            {heroMeta.updatedText}
          </span>
        </div>
      </div>
    </section>
  );
}